import { UserAddress } from '../types/UserAddress';

type Props = {
  selectedRecord: UserAddress | null;
  setSelectedRecord: (selectedRecord: UserAddress | null) => void;
};
const RecordModal = (props: Props) => {
  const { selectedRecord, setSelectedRecord } = props;

  const closeModal = () => {
    setSelectedRecord(null);
    (document.getElementById('record_modal') as HTMLFormElement)?.close();
  };
  return (
    <dialog id={'record_modal'} className="modal">
      {selectedRecord ? (
        <div className="modal-box max-w-4xl">
          {/* Record Name and creation info */}
          <div className="flex flex-row justify-between">
            <div className="flex flex-row self-center font-bold text-lg text-primary">
              More Info - {selectedRecord.guid}
            </div>
            <div className="flex flex-row gap-2 text-primary">
              <div>Created on: {selectedRecord.createdDate.slice(0, 10)}</div>
              <div>Created By: {selectedRecord.createdBy}</div>
            </div>
          </div>
          <div className="divider divider-primary m-0" />
          {/* Record Information */}
          <div className="grid grid-cols-3 justify-evenly w-full p-4 ">
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">Mailed:</div>
              <div>{!selectedRecord.mailed ? 'Not Mailed' : selectedRecord.mailedDate}</div>
            </div>
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">Reason:</div>
              <div>{selectedRecord.reason}</div>
            </div>
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">Address:</div>
              <div>{selectedRecord.addressLine1}</div>
            </div>
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">City:</div>
              <div>{selectedRecord.city}</div>
            </div>
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">State:</div>
              <div>{selectedRecord.state}</div>
            </div>
            <div className="flex flex-row gap-4 w-56 m-2">
              <div className="text-primary">Country:</div>
              <div>{selectedRecord.country}</div>
            </div>
          </div>
          <div className="flex flex-row w-full justify-end">
            <button className="btn btn-error btn-sm btn-outline  " onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      ) : (
        <div className="loading loading-spinner" />
      )}
      <form method="dialog" className="modal-backdrop absolute w-full h-full" onClick={closeModal}>
        <button>Close</button>
      </form>
    </dialog>
  );
};

export default RecordModal;
